import './PaymentHistoryLegends.scss'
const PaymentHistoryLegends = () => {

    return (
        <div className="receipt-legend">
            <div className="legend-item">
                <span className="legend-bar refunded"></span>
                <span>Reembolsado</span>
            </div>

            <div className="legend-item">
                <span className="legend-bar partial"></span>
                <span>Parcialmente reembolsado</span>
            </div>

            <div className="legend-item">
                <span className="legend-bar cancelled"></span>
                <span>Cancelado</span>
            </div>
        </div>
    )
}
export default PaymentHistoryLegends;